import { http } from '@/http'

export default {
  list(businessId) {
    return http.get(`/api/v1/business/${businessId}/location`)
  },
  get(businessId, id) {
    return http.get(`/api/v1/business/${businessId}/location/${id}`)
  },
  save(businessId, data) {
    return http.post(`/api/v1/business/${businessId}/location`, data)
  },
  update(businessId, id, data) {
    return http.put(`/api/v1/business/${businessId}/location/${id}`, data)
  },
  toggleStatus(businessId, id, status) {
    return http.put(`/api/v1/business/${businessId}/location/${id}/status`, null, { params: { status } })
  },
  delete(businessId, id) {
    return http.delete(`/api/v1/business/${businessId}/location/${id}`)
  }
}
